@let letsikring = letsikringRisiko();
<div [formGroup]="form()">
  <section formGroupName="gaeldendeRevision">
    <section formGroupName="letsikringRisiko">
      <div class="detail-section-header">Risikodækning</div>
      @if (letregisterService.isFlydendeDaekning(letsikring)) {
        <app-detail-row [editMode]="editMode()" label="Produkt id">
          {{ letsikring.letsikringRisikoProduktValg?.ramme?.produktTypeNummer }}
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Prisgruppe">
          {{ letsikring.letsikringRisikoProduktValg?.prisgruppe }}
        </app-detail-row>
      } @else {
        <app-detail-row [editMode]="editMode()" label="RAP-nr.">
          {{ letsikring.gruppeProdukt?.produktType?.produktTypeNummer }}-{{
            letsikring.gruppeProdukt?.underKode | number: '3.0'
          }}
          <ng-template #editor>
            <p-select
              [options]="gruppeProduktOptions()"
              class="w-[178px]"
              formControlName="gruppeProduktId"
              optionLabel="kode"
              optionValue="gruppeProduktId"
              appendTo="body"
              (onChange)="onGruppeProduktChange($event)" />
          </ng-template>
        </app-detail-row>
      }

      @if (letsikring.skattekode === 2) {
        <app-detail-row [editMode]="editMode()" label="Udbetaling antal år">
          <div>10</div>
        </app-detail-row>
      }

      <app-detail-row [editMode]="editMode()" label="Ophørsdato">
        {{ letsikring.risikoOphoer | date: 'dd-MM-yyyy' }}
      </app-detail-row>

      @if (!letregisterService.isFlydendeDaekning(letsikring)) {
        <app-detail-row [editMode]="editMode()" label="Skattekode">
          {{ letsikring.skattekode }}
          <ng-template #editor>
            <p-input-number
              formControlName="skattekode"
              locale="da"
              [maxFractionDigits]="0"
              [maxlength]="1"
              mode="decimal" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Dækning">
          {{
            letregisterService.getGruppeProduktAarsData(letsikring)?.ydelse
              | number: '1.2'
          }}
          <ng-template #editor>
            <app-display-decimal formControlName="_ydelse" />
          </ng-template>
        </app-detail-row>
      }

      @if (letregisterService.isFlydendeDaekning(letsikring)) {
        <section formGroupName="letsikringRisikoProduktValg">
          <app-detail-row [editMode]="editMode()" label="Dækning">
            {{
              letsikring.letsikringRisikoProduktValg?.daekningsstoerrelse
                | number: '1.2'
            }}
            <ng-template #editor>
              <p-input-number
                formControlName="daekningsstoerrelse"
                locale="da"
                [maxFractionDigits]="2"
                mode="decimal" />
            </ng-template>
          </app-detail-row>

          <app-detail-row [editMode]="editMode()" label="Skattekode">
            {{ letsikring.letsikringRisikoProduktValg?.skattekode }}
            <ng-template #editor>
              <p-input-number
                formControlName="skattekode"
                locale="da"
                [maxFractionDigits]="0"
                [maxlength]="1"
                mode="decimal" />
            </ng-template>
          </app-detail-row>

          <app-detail-row [editMode]="editMode()" label="Betalingsfrekvens">
            {{ letsikring.letsikringRisikoProduktValg?.frekvensForIndbetaling }}
            <ng-template #editor>
              <p-select
                [options]="frekvensForIndbetalingOptions"
                class="w-[178px]"
                formControlName="frekvensForIndbetaling"
                optionLabel="text"
                optionValue="value"
                appendTo="body" />
            </ng-template>
          </app-detail-row>
        </section>
      }

      <app-detail-row [editMode]="editMode()" label="Præmiefritagelse">
        @if (letregisterService.isFlydendeDaekning(letsikring)) {
          {{ letsikring.produktPris?.praemiefritagelsesFaktor | boolean }}
        } @else {
          {{
            letsikring.gruppeProdukt?.produktType?.praemieFritagelse | boolean
          }}
        }
      </app-detail-row>

      @if (letsikring.produktType === 'LetsikringTabAfErhvervsevneBasis') {
        <app-detail-row [editMode]="editMode()" label="Under udbetaling">
          {{ letsikring.underUdbetaling | boolean }}
          <ng-template #editor>
            <p-checkbox formControlName="underUdbetaling" [binary]="true" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Karens">
          @if (letregisterService.isFlydendeDaekning(letsikring)) {
            {{ letsikring.letsikringRisikoProduktValg?.ramme?.karensMdr }}
          } @else {
            {{ letsikring.gruppeProdukt?.produktType?.karensMdr }}
          }
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Årlig indkomst">
          {{ letsikring.aarligIndkomst | number: '1.2' }}
          <ng-template #editor>
            <p-input-number
              formControlName="aarligIndkomst"
              locale="da"
              [maxFractionDigits]="2"
              mode="decimal" />
          </ng-template>
        </app-detail-row>
      }

      @if (
        [
          'LetsikringInvalidesumBasis',
          'LetsikringTabAfErhvervsevneBasis',
          'LetsikringAfSygdom',
          'LetsikringVedKritiskSygdom',
          'LetsikringLivsforsikringBasis',
        ].includes(letsikring.produktType!)
      ) {
        <app-detail-row
          [editMode]="editMode()"
          label="Betaling via frie midler">
          {{ letsikring.betalingViaFrieMidler | boolean }}
          <ng-template #editor>
            <p-checkbox
              formControlName="betalingViaFrieMidler"
              [binary]="true" />
          </ng-template>
        </app-detail-row>
      }

      @if (
        letsikring.forsikredeId &&
        [
          'LetsikringVedDoed',
          'LetsikringAfLaanOgKredit',
          'LetsikringLivsforsikringBasis',
        ].includes(letsikring.produktType!)
      ) {
        <div class="detail-section-header">Begunstigelse</div>
        <app-detail-row [editMode]="editMode()" label="Nærmeste pårørende">
          {{ letsikring.naermestePaaroerendeBegunstigelse | boolean }}
        </app-detail-row>
      }

      @if (letsikring.produktType === 'LetsikringAfBarn') {
        <div class="detail-section-header">Barn</div>
        <app-detail-row [editMode]="editMode()" label="Ophørsalder barn">
          @if (letregisterService.isFlydendeDaekning(letsikring)) {
            {{
              letsikring.letsikringRisikoProduktValg?.ramme
                ?.barnRisikoOphoerAlder
            }}
          } @else {
            {{ letsikring.gruppeProdukt?.produktType?.barnRisikoOphoerAlder }}
          }
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Barn"> </app-detail-row>
        <app-detail-row [editMode]="editMode()" label="CPR-nummer">
          {{ letsikring.barn?.cprNummer }}
          <ng-template #editor>
            <app-kunde-selector
              [value]="letsikring.barn?.cprNummer"
              (kundeSelected)="onBarnSelected($event)" />
          </ng-template>
        </app-detail-row>
        <app-detail-row [editMode]="editMode()" label="Navn">
          {{ letsikring.barn?.navn }}
          <ng-template #editor>
            <div class="ml-3">
              {{ form().value.gaeldendeRevision.letsikringRisiko?.barnNavn }}
            </div>
          </ng-template>
        </app-detail-row>
      }

      @if (
        ['LetsikringAfLaanOgKredit', 'LetsikringVedDoed'].includes(
          letsikring.produktType!
        )
      ) {
        <div class="detail-section-header">Krydsliv</div>
        <app-detail-row [editMode]="editMode()" label="Forsikrede">
        </app-detail-row>
        <app-detail-row [editMode]="editMode()" label="CPR-nummer">
          {{ letsikring.forsikrede?.cprNummer | cprNummer }}
          <ng-template #editor>
            <app-kunde-selector
              [value]="letsikring.forsikrede?.cprNummer"
              (kundeSelected)="onForsikredeSelected($event)" />
          </ng-template>
        </app-detail-row>
        <app-detail-row [editMode]="editMode()" label="Navn">
          {{ letsikring.forsikrede?.navn }}
          <ng-template #editor>
            <div class="ml-3">
              {{
                form().value.gaeldendeRevision.letsikringRisiko?.forsikredeNavn
              }}
            </div>
          </ng-template>
        </app-detail-row>
      }

      <div class="detail-section-header">Betaling</div>

      <app-konto
        [editMode]="editMode()"
        [formPath]="[
          'gaeldendeRevision',
          'letsikringRisiko',
          'debiteringskonto',
        ]"
        [konto]="letsikring.debiteringskonto" />

      <app-detail-row [editMode]="editMode()" label="Årlig pris">
        @if (letregisterService.isFlydendeDaekning(letsikring)) {
          {{ letsikring.letsikringRisikoProduktValg?.pris | number: '1.2' }}
        } @else {
          {{
            letregisterService.getGruppeProduktAarsData(letsikring)?.aarligPris
              | number: '1.2'
          }}
        }
        <ng-template #editor>
          <div>
            @if (letregisterService.isFlydendeDaekning(letsikring)) {
              {{ letsikring.letsikringRisikoProduktValg?.pris | number: '1.2' }}
            } @else {
              <app-display-decimal formControlName="_pris" />
            }
          </div>
        </ng-template>
        <ng-template #help>
          Feltet indeholder den aktuelle årlige pris på dækningen, som er
          defineret ud fra det valgte Rap-nummer.
        </ng-template>
      </app-detail-row>

      @if (allowStraksOpkraevning() && editMode()) {
        <app-detail-row [editMode]="editMode()" label="Straksopkrævning">
          <ng-template #editor>
            <p-checkbox
              formControlName="straksopkraevningValgt"
              [binary]="true" />
          </ng-template>
          <ng-template #help>
            Feltet skal indeholde beløbet, som kunden skal betale for den
            aktuelle revision af Letsikringen. (Ved nytegning er denne det samme
            som stumppræmien)<br /><br />

            Ved ændringer beregnes denne som forskellen mellem det allerede
            indbetalte beløb (hvor det antages, at tidligere opkrævninger
            allerede er betalt) og prisen for den aktuelle revision af
            Letsikringen.
          </ng-template>
        </app-detail-row>
        @if (
          form().value.gaeldendeRevision?.letsikringRisiko
            ?.straksopkraevningValgt
        ) {
          <section formGroupName="straksopkraevning">
            <app-detail-row
              [editMode]="editMode()"
              label="Straksbetaling ifm. oprettelse/ændring">
              <ng-template #editor>
                <p-input-number
                  formControlName="opkraevningsBeloeb"
                  locale="da"
                  [maxFractionDigits]="2"
                  mode="decimal" />
              </ng-template>
            </app-detail-row>

            <app-detail-row
              [editMode]="editMode()"
              label="Opkrævningsperiode fra">
              <ng-template #editor>
                <app-let-date-picker formControlName="periodeFra" />
              </ng-template>
            </app-detail-row>

            <app-detail-row
              [editMode]="editMode()"
              label="Opkrævningsperiode til">
              <ng-template #editor>
                <app-let-date-picker formControlName="periodeTil" />
              </ng-template>
            </app-detail-row>

            <app-detail-row
              [editMode]="editMode()"
              label="Beskrivelse (Besked til kunde)">
              <ng-template #editor>
                <textarea
                  rows="5"
                  cols="50"
                  pTextarea
                  formControlName="kommentar"></textarea>
              </ng-template>
            </app-detail-row>
          </section>
        }
      }

      <app-detail-row>
        <p-button
          label="Vis opkrævningshistorik"
          size="small"
          outlined
          (click)="visOpkraevningshistorik()" />
      </app-detail-row>
      <div class="detail-section-header">Pantsætning</div>
      <app-detail-row [editMode]="editMode()" label="Pantsat">
        {{ letsikring.pantsatType }}
        <ng-template #editor>
          <p-select
            [options]="pantsatTypeOptions"
            class="w-[230px]"
            formControlName="pantsatType"
            optionLabel="text"
            optionValue="value"
            appendTo="body" />
        </ng-template>
      </app-detail-row>

      <div class="detail-section-header">Dokumentoplysninger</div>
      <app-detail-row [editMode]="editMode()" label="Tilbuds nr.">
        {{ getTilbudsnr() }}
      </app-detail-row>
      <app-detail-row [editMode]="editMode()" label="Navn">
        {{ getAftaledokument()?.emne }}
      </app-detail-row>
      <app-detail-row [editMode]="editMode()" label="Underskriftsmetode">
        {{
          getAftaledokument()?.signeringStatus?.signeringsMetode || 'På papir'
        }}
      </app-detail-row>

      <div class="detail-section-header">Helbred</div>
      <app-detail-row [editMode]="editMode()" label="Oprettet den">
        {{ personHelbred()?.oprettelsesDato | date: 'dd-MM-yyyy HH:mm' }}
      </app-detail-row>
      <app-detail-row [editMode]="editMode()" label="SpørgeskemaId">
        {{ personHelbred()?.spoergeskemaGuid }}
      </app-detail-row>
    </section>
  </section>
</div>

<p-dialog
  header="Opkrævningshistorik"
  [modal]="true"
  [(visible)]="showOpkraevningsHistorik"
  [style]="{
    minWidth: '900px',
    minHeight: '600px',
  }">
  <div>
    <div class="flex items-center">
      <p-radiobutton name="visning" value="alle" [(ngModel)]="visRevision" />
      <label class="ml-2"
        >Alle revisioner for Letsikring {{ letsikringNr() }}</label
      >
    </div>
    <div class="flex items-center">
      <p-radiobutton name="visning" value="valgt" [(ngModel)]="visRevision" />
      <label class="ml-2">Valgt revision {{ revision().revisionNr }}</label>
    </div>
  </div>
  <p-table
    [value]="opkraevningsHistorikFiltered()"
    stripedRows
    class="p-datatable-sm lp-table">
    <ng-template pTemplate="header">
      <tr>
        <th>Rev</th>
        <th>Periode</th>
        <th>Type</th>
        <th class="!text-right">Beløb</th>
        <th class="!text-right">Provision</th>
        <th>Kommentar</th>
      </tr>
    </ng-template>
    <ng-template
      [appTableRow]="opkraevningsHistorikFiltered()"
      pTemplate="body"
      let-item>
      <tr [pSelectableRow]="item">
        <td>{{ item.revisionNr }}</td>
        <td class="numbers">
          {{ item.periodeFra | date: 'dd-MM-yyyy' }} -
          {{ item.periodeTil | date: 'dd-MM-yyyy' }}
        </td>
        <td>{{ item.opkraevningsType }}</td>
        <td class="!text-right">
          {{ item.opkraevningsBeloeb | number: '1.2' }}
        </td>
        <td class="!text-right">{{ item.provision | number: '1.2' }}</td>
        <td>{{ item.kommentar }}</td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>
